import { render, staticRenderFns } from "./CgddDetail.vue?vue&type=template&id=4019d63e&scoped=true&"
import script from "./CgddDetail.vue?vue&type=script&lang=js&"
export * from "./CgddDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./CgddDetail.vue?vue&type=style&index=1&id=4019d63e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4019d63e",
  null
  
)

export default component.exports